import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  style: {"height":"90vh"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w100 title mc mt40" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969","float":"none"}
  }, /*#__PURE__*/_toDisplayString(`カレンダーから出席可能表を作成`))
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = {
  class: "ofs w100",
  style: {"padding":"0 40px 0 40px","height":"calc(100vh - 200px)"}
}
const _hoisted_5 = { class: "w100" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w10 fs20 fw600" }, "作成する期間を指定", -1)
const _hoisted_7 = { style: {"padding-left":"140px"} }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt7 ml5 mr5" }, "~", -1)
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = { class: "mt10 mb10 ml10" }
const _hoisted_13 = { class: "fl mr20" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_19 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "キャンセル", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}, "確定", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { class: "w100 mb10" }
const _hoisted_27 = { class: "fl ml40 mt20" }
const _hoisted_28 = ["src"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = {
  class: "fl ofs w100",
  style: {"padding":"0 0 0 40px","height":"calc(100vh - 200px)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_SelectAttendeesWithAddressbook = _resolveComponent("SelectAttendeesWithAddressbook")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "ImportFromCalendarModal",
    "content-class": "modalContent shadowContent rad10 modalWide posFi",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.vrm.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.viewType == `appo`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Dropdown, {
                      class: "form-group fl",
                      style: {"width":"140px"}
                    }, {
                      dropdown: _withCtx(() => [
                        _createElementVNode("li", null, [
                          _createVNode(_component_date_picker, {
                            modelValue: _ctx.startDate,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startDate) = $event)),
                            format: "yyyy/MM/dd"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control dropdown-toggle",
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.startDate]
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _hoisted_9,
                    _createVNode(_component_Dropdown, {
                      class: "form-group fl",
                      style: {"width":"140px"}
                    }, {
                      dropdown: _withCtx(() => [
                        _createElementVNode("li", null, [
                          _createVNode(_component_date_picker, {
                            modelValue: _ctx.endDate,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endDate) = $event)),
                            format: "yyyy/MM/dd"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control dropdown-toggle",
                            type: "text",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endDate) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.endDate]
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _hoisted_11
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_SelectTag, {
                    name: "fix_vote_type",
                    id: "fix_vote_type",
                    class: "fs14 roundForm",
                    style: {"min-width":"360px","height":"50px"},
                    options: _ctx.SelectUtil.votedRoomFixTypes.map(e => e.name),
                    defaultOption: _ctx.defaultVotedOption(),
                    onSelectValue: _ctx.selectVoteFixType,
                    isDisabled: false
                  }, null, 8, ["options", "defaultOption", "onSelectValue"])
                ]),
                _hoisted_14,
                _hoisted_15
              ]),
              _hoisted_16
            ]),
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("section", {
                  class: "llgreyBg dgrey fs16 pointer centered",
                  style: {"line-height":"50px","height":"50px"},
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickCancel && _ctx.clickCancel(...args)))
                }, _hoisted_21)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("section", {
                  class: "w100 skyblueBg fs16 pointer centered",
                  style: {"line-height":"50px","height":"50px"},
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickOK && _ctx.clickOK(...args)))
                }, _hoisted_24)
              ])
            ])
          ]))
        : (_ctx.viewType == `attendees`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_left.png`),
                    width: "36",
                    height: "36",
                    class: "pointer",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clickPreStep && _ctx.clickPreStep(...args)))
                  }, null, 8, _hoisted_28)
                ]),
                _hoisted_29
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_SelectAttendeesWithAddressbook, { viewType: _ctx.viewType }, null, 8, ["viewType"])
              ])
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}